module.exports = __webpack_public_path__ + "img/icon_withdraw_logo.9973ae70.png";